// extracted by mini-css-extract-plugin
export default {"container":"BEditQueryDialog-module_container_eeeced11","queryContainer":"BEditQueryDialog-module_queryContainer_fda3abc7"};